import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CrossAssetAnalysisSidepanelComponent from './CrossAssetAnalysisSidepanelComponent';
import { getModel } from './selectors';
import * as actions from './actions';
import { getApiAssetCapability, getAssetDetailsV2 } from '../../AssetPowertrainSelector/actions';
import './style.scss';
import { filterTabs } from 'helpers/constants';
import { setSelectedAssetAction } from '../../../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/AssetOverview/actions';

const CrossAssetAnalysisSidepanelContainer = (props) => {
    useEffect(() => {
        if (props?.model?.selectedAsset?.id) {
            props.actions.setActiveTabAction(filterTabs.ASSETS);
        }
        return () => {
            props.actions.clearStore();
        };
    }, []);
    return <CrossAssetAnalysisSidepanelComponent {...props} />;
};


const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            ...actions,
            getApiAssetCapability,
            getAssetDetailsV2,
            setSelectedAssetAction
        }, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CrossAssetAnalysisSidepanelContainer);

